/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../../../i18n';
import { SUDataset } from '../../../../types/superuser/dataset/SUDataset';
import { useDatasetsDetailPanelStyles } from './DatasetsDetailPanel.styles';

type DatasetsDetailPanelProps = {
  rowData: SUDataset;
  getSize: (size: string) => string;
  prepareDate: (date: string) => string;
};

export function DatasetsDetailPanel(props: DatasetsDetailPanelProps) {
  const classes = useDatasetsDetailPanelStyles();
  const { t } = useTranslation(Namespaces.Admin);
  const { rowData, getSize, prepareDate } = props;

  return (
    <div className={classes.detailPanelRoot}>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.id')}</b>: <span>{rowData.id}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.name')}</b>: <span>{rowData.name}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.description')}</b>:&nbsp;
        <span>{rowData.description}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.raw_size')}</b>:&nbsp;
        <span>{getSize(rowData.rawSizeMb)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.import_size')}</b>:&nbsp;
        <span>{getSize(rowData.importSizeMb)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.final_size')}</b>:&nbsp;
        <span>{getSize(rowData.finalSizeMb)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.created_at')}</b>:&nbsp;
        <span>{prepareDate(rowData.createdAt)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.updated_at')}</b>:&nbsp;
        <span>{prepareDate(rowData.updatedAt)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.visible')}</b>:&nbsp;
        <span>{rowData.visible ? t('datasets.table.labels.yes') : t('datasets.table.labels.no')}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.exists')}</b>:&nbsp;
        <span>{rowData.exists ? t('datasets.table.labels.yes') : t('datasets.table.labels.no')}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.identifier')}</b>:&nbsp;
        <span>{rowData.identifier}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.category')}</b>:&nbsp;
        <span>{rowData.category.identifier}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.schema')}</b>:&nbsp;
        <span>{rowData.schema}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.database')}</b>:&nbsp;
        <span>{rowData.database}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.table.labels.imports')}</b>:&nbsp;
        <span>{rowData.clusters}</span>
      </div>
    </div>
  );
}
